import { SchoolService, BaseService } from "@/services/school.service";
import moment from "moment";

function EvidenceFilter(calendar, years, group, date, tags, includePupilTags) {
    this.calendar = calendar;
    this.years = years;
    this.group = group;
    this.date = date;
    this.tags = tags;
    this.includePupilTags = includePupilTags
}

const EvidenceService = {

    getByUnitOrLesson(searchType, objectId, group, page, pageSize) {
        let groupParam = (group != undefined && group.id > 0) ? "&class=" + group.name.toLowerCase() : ""

        return SchoolService.getAll(searchType + "/" + objectId + "/evidences?page=" + page + "&results_per_page=" + pageSize + groupParam)
    },

    getWithFilter(filterValues, page, pageSize) {

        // calendar
        let cal = filterValues.calendar.value

        // group
        let group = (filterValues.group != undefined && filterValues.group.id > 0) ? "&class=" + filterValues.group.name.toLowerCase() : ""

        // years
        let years = filterValues.years != undefined ? "&yeargroups=" + filterValues.years.join() : ""

        // tags 
        var tags = ""
        if (filterValues.tags.length > 0) {
            let results = filterValues.tags.substring(0,50).replaceAll("#", "").split(' ').join(',').split(',')
            tags = "&tags=" + results
        }

        var includePupilTags = ""
        if (filterValues.includePupilTags) {
            includePupilTags = "&types=pupil_tags"
        }

        // dates
        var since = ""
        var until = ""
        if (filterValues.date != undefined) {
            since = filterValues.date.since != undefined ? "&since=" + moment(filterValues.date.since).format("YYYY-MM-DD") : ""
            until = filterValues.date.until != undefined ? "&until=" + moment(filterValues.date.until).format("YYYY-MM-DD")  : ""
        }

        return SchoolService.getAll("evidences?stored=" + cal + group + years + since + until + tags + includePupilTags + "&page=" + page + "&results_per_page=" + pageSize  + "&include=course")
    },

    // crud

    add(payload) {
    	return SchoolService.create("evidences", payload)
    },

    update(result) {
    	return SchoolService.update("evidences", result.identifier, result)
    },


    delete(result) {
    	return SchoolService.delete("evidences", result.identifier, null)
    },

    // pupils

    getPupils(object) {
        return SchoolService.getAll("evidences/" + object.identifier + "/pupils")
    },

    addPupil(payload) {
        return SchoolService.create("evidences/pupils", payload)
    },

    deletePupil(result, object) {
       return SchoolService.delete("evidences/" + result.identifier + "/pupils", object.identifier, null) 
    },

    // outcomes

    getOutcomes(object) {
        return SchoolService.getAll("evidences/" + object.identifier + "/outcomes")
    },


    addOutcome(payload) {
        return SchoolService.create("evidences/outcomes", payload)
    },

    deleteOutcome(result, object) {
       return SchoolService.delete("evidences/" + result.identifier + "/outcomes", object.identifier, null) 
    }
    
}

export { EvidenceService, EvidenceFilter };